<ng-container [ngSwitch]="(modal | async)?.name">
    <course-support-pin-dialog
        *ngSwitchCase="'showPin'"
        [pinCode]="(modal | async).params.pinCode"
    ></course-support-pin-dialog>
</ng-container>
